// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function speiValidator(): ?UserInputValidationError {
  return VALID;
}
